import * as React from 'react';
import { MainGrid, MainContent } from '../../components/UI/MainUI';
import TopBar from '../Site/TopBar';
import { withThemer, ThemerProps } from '../../helpers/withThemer';
import { ThemeProvider } from 'styled-components';
import Footer from '../Site/Footer';

interface DashProps {
  children: React.ReactNode;
}

type Props = ThemerProps & DashProps;

const MainLayout: React.SFC<Props> = ({ children, theme, updateTheme }) => (
  <ThemeProvider theme={{ mode: theme }}>
    <MainGrid>
      <TopBar />
      <MainContent>{children}</MainContent>
      <Footer />
    </MainGrid>
  </ThemeProvider>
);

export default withThemer(MainLayout);



// WEBPACK FOOTER //
// ./src/containers/Layouts/MainLayout.tsx